import * as React from 'react'

interface ReadMoreTextProps {
    children: string
    className?: string
    style?: React.CSSProperties
    expandLabel?: string
    collapseLabel?: string
    textClassName?: string
    textStyle?: React.CSSProperties
    buttonClassName?: string
    buttonStyle?: React.CSSProperties
    lettersLimit?: number
    onExpandChange?: (expanded: boolean) => void
}

const ReadMoreText: React.FC<ReadMoreTextProps> = ({
    children,
    className,
    style,
    expandLabel = 'Read more',
    collapseLabel = 'Read less',
    textClassName,
    textStyle,
    buttonClassName,
    buttonStyle,
    lettersLimit = 500,
    onExpandChange,
}) => {
    const [expanded, setExpanded] = React.useState(false)

    const onShowMore = React.useCallback(() => {
        setExpanded(true)
        onExpandChange?.(true)
    }, [onExpandChange])

    const onShowLess = React.useCallback(() => {
        setExpanded(false)
        onExpandChange?.(false)
    }, [onExpandChange])

    const text = new String(children)
    const textExpander = expanded ? children : text.substring(0, lettersLimit) + '...'

    return (
        <div className={className} style={{ display: 'block', ...style }}>
            <p className={textClassName} style={{ display: 'inline', ...textStyle }}>
                {textExpander}
            </p>
            {text.length > lettersLimit && (
                <button
                    className={buttonClassName}
                    style={{
                        display: 'inline',
                        color: 'unset',
                        backgroundColor: 'unset',
                        border: 'unset',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        paddingLeft: '8px',
                        paddingRight: '8px',
                        ...buttonStyle,
                    }}
                    onClick={expanded ? onShowLess : onShowMore}
                >
                    {expanded ? collapseLabel : expandLabel}
                </button>
            )}
        </div>
    )
}

export default ReadMoreText
